!function () {
  "use strict";

class SpRemoveBtn extends HTMLElement {
  constructor() {
    super();
    this.querySelector('#ab-protection-i').addEventListener('change', (event) => {
      event.preventDefault();
      const selectors = ['cart-items', '#CartDrawer cart-drawer-items'];
      let refreshdrawer=false;
      for (const s of selectors) {
        refreshdrawer = (s === 'cart-items');
        const i = document.querySelector(s);
        if(i){          
           i.updateQuantity(this.dataset.index, 0, event);
           if(refreshdrawer){setTimeout(this.refreshCartDrawer,3000);break;}      
        } 
      }
    });}

 refreshCartDrawer() {
    const CART_DRAWER_SECTION_ID = 'cart-drawer';
    fetch(`/?sections=${CART_DRAWER_SECTION_ID}`)
      .then((res) => res.json())
      .then((data) => {
        const newHtml = data[CART_DRAWER_SECTION_ID];
        if (!newHtml) return;
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(newHtml, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const s of selectors) {
            const targetEl = document.querySelector(s);
            const sourceEl = newDoc.querySelector(s);
        if (targetEl && sourceEl) {
          targetEl.innerHTML = sourceEl.innerHTML;
        }
        }  
      })
      .catch((err) => console.error('[CartDrawerSync] 刷新失败:', err));
  }  
}
if (!customElements.get('sp-remove')) {
 customElements.define('sp-remove', SpRemoveBtn);
}

if (!customElements.get('sp-box')) {
  customElements.define(
    'sp-box',
class SpBox extends HTMLElement {
      constructor() {
        super();

        this.jmin = 7*14;
        this.ph = 'ship'+'ping'+'-prote'+'ction';
        this.percentage = 0.021;
        this.cartMf=document.getElementById('main-cart-footer') || undefined;
        this.cartMf=this.cartMf?.querySelector('.js-contents'); //cartfooter
        this.cartDf=document.querySelector('.cart-drawer__footer');
      }

      upRF(r){ 
        if(this.cartMf){
         this.cartMf.innerHTML = this.getSectionInnerHTML(r.sections['cart-drawer'],'.cart-drawer__footer');
        }
        this.cartDf.innerHTML = this.getSectionInnerHTML(r.sections['cart-drawer'],'.cart-drawer__footer');
      } 

    getCart(){ 
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const cItems = cart.items.filter(item => item.handle != this.ph)??[];
          const oldSp = cart.items.find(item => item.handle === this.ph) ?? false;
          if (cItems.length > 0) {
              if (oldSp && cart.total_price>150000){   
                this.outTotal(oldSp.id);
              }
              else{
                const m=cart.total_price;
                const i=oldSp.final_line_price
                this.upCart(cart,oldSp,m-i);
              }
          }
          else{
            this.clearCart();
          }
        })
        .catch((e) => console.error('Error updating cart:', e));
    }  
      
    //当item变时
    upCart(c,f,m){ 
        const newP = parseFloat(m) * this.percentage;
        const newPrice = (newP< this.jmin) ? this.jmin : newP;
        this.getVariant(newPrice,f);
    }

      // 清空
      clearCart()
      {        
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          }
        })
        .catch((error) => console.error('clear Error:', error));
      }

      getVariant(t,f) {
        fetch(`/products/${this.ph}.js`)
        .then((response) => response.json())
        .then((d) => {              
            const v= this.getNewVariant(d,t);
            if(v!=0){          
            if (f){
              if (f.id != v.id) {       
                this.removeItem(f.id,v.id);
              }
              else if(f.quantity>1) {
                this.updateItemPrice(v.id);
              }
            }
          }
        });

      }

      getNewVariant(p, x) {
        if (!p.variants || p.variants.length === 0) return 0;
        let newV = p.variants[0];
        let minDifference = Math.abs(parseFloat(newV.price) - x);
        for (const v of p.variants) {
          const difference = Math.abs(parseFloat(v.price) - x);
          if (difference < minDifference) {
            newV = v;
            minDifference = difference;
          }
        }
        return newV;
      }

      addItem(id) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json',},
              body: JSON.stringify({
                id: id,
                quantity: 1,
              }),
            })        
            .then((response) => response.json())
            .then((d) => {
                this.upEl();
              })
           .catch((error) => console.error("add Error:", error));
      }
      
      removeItem(oid,vid) {
        if (oid > 0) {
          fetch(`/cart/change.js?id=${oid}&quantity=0`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            }
          })
          .then((response) => response.json())
          .then((d) => {
              if(vid > 0){
                this.addItem(vid);
               }
               else{
                this.upEl();
               }
              })
          .catch((error) => console.error("removing Error:", error));
        }
      }

      outTotal(id){          
          this.removeItem(id,0);          
          const t='Sorry, shipping protection cannot be purchased for this order because the total amount is limited to $1500 USD. Please contact us if you have any needs.';
          document.querySelector('#ab-spbox').textContent=t;          
      }

      updateItemPrice(vId) {
        if (vId > 0) {
          fetch(`/cart/change.js?id=${vId}&quantity=1`, {
            method: "POST",
            headers: { "Content-Type": "application/json", },
            /*body:JSON.stringify({
              id: vId,
              quantity: 1,
            }),  */
          });
        }
      }
     
      upEl() {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
              if(this.cartMf && selector==='.cart-drawer__footer'){
                this.cartMf.innerHTML=sourceElement.innerHTML;
              }
            }
          }          
        })
        .catch((e) => {
          console.error(e);
        });

       if (document.getElementById('main-cart-items')) {
       fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items tbody');
          document.getElementById('main-cart-items').querySelector('tbody').innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
       } 
        
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

    })
}

if (!customElements.get('sp-form')) {
  customElements.define(
    'sp-form',
    class SpForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false; 
        this.querySelector('#ab-protection-i').addEventListener('change', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('#ab-protection-i');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.sp=document.querySelector('sp-box');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('hidden');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'sp-form-a',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'sp-form-a',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
                this.sp.upRF(response);
              });
           
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('hidden');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.sp-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.sp-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          //if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          //this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

    }
  );
}

}();